import { useState, useEffect } from "react";
import "./top_projects.css";
import Mobile_Slider from "./mobile/Slider";
import Desktop_Slider from "./desktop/Slider";
const TopProjects = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);
  const [dots, setDots] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
    };

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Generate random dots
    const newDots = [];
    for (let i = 0; i < 30; i++) {
      newDots.push({
        id: i,
        top: `${Math.random() * 100}%`,
        left: `${Math.random() * 100}%`,
        delay: `${Math.random() * 4}s`,
        duration: `${3 + Math.random() * 2}s`,
      });
    }
    setDots(newDots);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="top_projects" id="top_projects">
      {/* Background elements */}
      <div className="top-projects-background">
        {/* Hexagon grid */}
        <div className="hexagon-grid"></div>

        {/* Geometric shapes */}
        <div className="geometric-container">
          <div className="geometric-shape shape-1"></div>
          <div className="geometric-shape shape-2"></div>
          <div className="geometric-shape shape-3"></div>
        </div>

        {/* Animated dots */}
        <div className="dots-container">
          {dots.map((dot) => (
            <div
              key={dot.id}
              className="dot"
              style={{
                top: dot.top,
                left: dot.left,
                animationDelay: dot.delay,
                animationDuration: dot.duration,
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="max-width">
        <h2 className="section-title">TOP PROJECTS</h2>
        {isLargeScreen ? <Desktop_Slider /> : <Mobile_Slider />}
      </div>
    </div>
  );
};

export default TopProjects;
